var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 3.5H11.8125M6.125 3.5C6.125 3.73206 6.03281 3.95462 5.86872 4.11872C5.70462 4.28281 5.48206 4.375 5.25 4.375C5.01794 4.375 4.79538 4.28281 4.63128 4.11872C4.46719 3.95462 4.375 3.73206 4.375 3.5M6.125 3.5C6.125 3.26794 6.03281 3.04538 5.86872 2.88128C5.70462 2.71719 5.48206 2.625 5.25 2.625C5.01794 2.625 4.79538 2.71719 4.63128 2.88128C4.46719 3.04538 4.375 3.26794 4.375 3.5M4.375 3.5H2.1875M6.125 10.5H11.8125M6.125 10.5C6.125 10.7321 6.03281 10.9546 5.86872 11.1187C5.70462 11.2828 5.48206 11.375 5.25 11.375C5.01794 11.375 4.79538 11.2828 4.63128 11.1187C4.46719 10.9546 4.375 10.7321 4.375 10.5M6.125 10.5C6.125 10.2679 6.03281 10.0454 5.86872 9.88128C5.70462 9.71719 5.48206 9.625 5.25 9.625C5.01794 9.625 4.79538 9.71719 4.63128 9.88128C4.46719 10.0454 4.375 10.2679 4.375 10.5M4.375 10.5H2.1875M9.625 7H11.8125M9.625 7C9.625 7.23206 9.53281 7.45462 9.36872 7.61872C9.20462 7.78281 8.98206 7.875 8.75 7.875C8.51794 7.875 8.29538 7.78281 8.13128 7.61872C7.96719 7.45462 7.875 7.23206 7.875 7M9.625 7C9.625 6.76794 9.53281 6.54538 9.36872 6.38128C9.20462 6.21719 8.98206 6.125 8.75 6.125C8.51794 6.125 8.29538 6.21719 8.13128 6.38128C7.96719 6.54538 7.875 6.76794 7.875 7M7.875 7H2.1875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.be053f118c5438488bc32a007ccea12d.svg";
export { ForwardRef as ReactComponent };